import React from "react";
import { Button } from "@mui/material";

const PILL = {
  borderRadius: "16px",
  fontSize: 12,
  textTransform: "capitalize",
  lineHeight: "16px",
  py: "7px",
  px: "15px",
  flexShrink: 0,
};

// Horizontal strip that holds the class pills. It scrolls sideways when the
// classes overflow; the scrollbar is hidden because the surrounding header chrome
// leaves no room for one. Shared so the SBG and legacy class layouts render an
// identical strip - only the pill behavior differs.
export const classPillStripSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  overflowX: "auto",
  maxWidth: { md: 380 },
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": { display: "none" },
};

// A single class pill, shared by both class layouts so they look the same. Colors
// come from the theme: a contained (primary) pill when active, outlined (primary)
// otherwise. Each caller owns the behavior through onClick - the SBG layout
// navigates to a class, the legacy layout toggles a multi-select filter.
export default function ClassPill({ label, active, onClick, ...props }) {
  return (
    <Button
      onClick={onClick}
      size="small"
      variant={active ? "contained" : "outlined"}
      disableElevation
      sx={PILL}
      {...props}
    >
      {label}
    </Button>
  );
}
